// Libraries
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Field, initialize, reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';

// Components
import CustomButton from '../../../../components/form/button';
import CustomInput from '../../../../components/form/input';

// Redux
import { closeLoader, openLoader } from '../../../../../redux-store/loader';

// Models
import SecurityModel from '../../../../../data/models/security/security';

// Locales
import I18n from '../../../../../i18n';

class ProDirectoryConfig extends React.Component {

    componentDidMount() {
        this.getConfigData();
    }

    getConfigData = async () => {

        const { dispatch } = this.props;

        try {

            this.props.openLoader();

            const responseInfo = await SecurityModel.getUserInfo(this.props.userid);

            const directoryFee = String(responseInfo?.data?.directoryFee || 10);

            dispatch(initialize(
                'proDirectoryConfigForm',
                {
                    directoryFee
                }
            ));

        } catch (error) {

            console.error(error);

        } finally {

            this.props.closeLoader();

        }

    };

    onSubmit = async (values) => {

        try {

            this.props.openLoader();

            const proUserId = this.props.userid;

            values.directoryFee = parseInt(values.directoryFee);

            await SecurityModel.updatedProDirectoryFee(proUserId, values);

        } catch (error) {

            console.error(error);

        } finally {

            this.props.closeLoader();

        }

    }

    render() {

        return (

            <Form name="proDirectoryConfigForm" onSubmit={this.props.handleSubmit(this.onSubmit)} noValidate>
                <div>
                    <Field
                        component={ CustomInput }
                        name="directoryFee"
                        type="number"
                        min={0}
                        label={ I18n.t('pro.directory.fee') } />
                </div>
                <div className="verticalPad">
                    <CustomButton type="submit" text={ I18n.t('pro.directory.save') } ></CustomButton>
                </div>
            </Form>

        );

    }

}

const validate = formValues => {

    const errors = {};

    if (_.isEmpty(formValues.directoryFee)) {

        errors.directoryFee = I18n.t('validations.required');

    }

    const directoryFee = Number(formValues.directoryFee);

    if (directoryFee < 0) {

        errors.directoryFee = I18n.t('validations.required');

    }

    return errors;

};

export default reduxForm({
    form: 'proDirectoryConfigForm',
    touchOnBlur: true,
    touchOnChange: false,
    validate,
})(connect(null, { closeLoader, openLoader })(ProDirectoryConfig));